import { render, staticRenderFns } from "./design copy.vue?vue&type=template&id=0f9936b0"
import script from "./design copy.vue?vue&type=script&lang=js"
export * from "./design copy.vue?vue&type=script&lang=js"
import style0 from "./design copy.vue?vue&type=style&index=0&id=0f9936b0&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports